var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "d-flex justify-content-center mb-1" },
      [
        _vm.loadingSpinner
          ? _c("b-spinner", {
              staticStyle: { width: "3rem", height: "3rem" },
              attrs: { variant: "success", span: "Spinning", block: "" },
            })
          : _vm._e(),
      ],
      1
    ),
    !_vm.loadingSpinner
      ? _c(
          "section",
          { staticClass: "invoice-add-wrapper" },
          [
            _c(
              "b-row",
              { staticClass: "invoice-add" },
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", xl: "9", md: "8" } },
                  [
                    _c("validation-observer", {
                      ref: "purchaseorder",
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (ref) {
                              var invalid = ref.invalid
                              return [
                                _c(
                                  "b-form",
                                  {
                                    on: {
                                      submit: function ($event) {
                                        $event.preventDefault()
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "b-card",
                                      {
                                        staticClass: "invoice-preview-card",
                                        attrs: { "no-body": "" },
                                      },
                                      [
                                        _c(
                                          "b-card-body",
                                          {
                                            staticClass: "invoice-padding pb-0",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "row align-items-center mb-2",
                                              },
                                              [
                                                _c("div", {}, [_c("Logo")], 1),
                                                _c(
                                                  "div",
                                                  { staticClass: "col-9" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {},
                                                      [_c("CompanyName")],
                                                      1
                                                    ),
                                                    _c(
                                                      "div",
                                                      {},
                                                      [_c("Address")],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-end flex-md-row flex-column invoice-spacing mt-0",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "invoice-number-date mt-md-0 mt-2",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex align-items-center justify-content-md-end mb-1",
                                                      },
                                                      [
                                                        _c(
                                                          "h4",
                                                          {
                                                            staticClass:
                                                              "invoice-title",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Purchase Invoice #" +
                                                                _vm._s(
                                                                  _vm
                                                                    .purchaseorderId
                                                                    .orderNumber
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex align-items-center mb-1",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "title",
                                                          },
                                                          [_vm._v(" Date: ")]
                                                        ),
                                                        _c("flat-pickr", {
                                                          staticClass:
                                                            "form-control invoice-edit-input",
                                                          attrs: {
                                                            config: _vm.config,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.issuedDate,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.issuedDate =
                                                                $$v
                                                            },
                                                            expression:
                                                              "issuedDate",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules: "required",
                                                        name: "Due Date",
                                                        vid: "Due Date",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "d-flex align-items-center",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "title",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " Due Date: "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "flat-pickr",
                                                                      {
                                                                        class: [
                                                                          {
                                                                            "is-invalid":
                                                                              errors.length,
                                                                          },
                                                                          "form-control invoice-edit-input",
                                                                        ],
                                                                        attrs: {
                                                                          config:
                                                                            _vm.configDue,
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .purchaseorderId
                                                                              .dueDate,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.purchaseorderId,
                                                                                "dueDate",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "purchaseorderId.dueDate",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                errors.length
                                                                  ? _c(
                                                                      "small",
                                                                      {
                                                                        staticClass:
                                                                          "text-danger",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            errors[0]
                                                                          )
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c("hr", {
                                          staticClass: "invoice-spacing",
                                        }),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex justify-content-center align-items-center",
                                          },
                                          [
                                            _vm.loadInvoiceData
                                              ? _c("b-spinner", {
                                                  staticStyle: {
                                                    width: "3rem",
                                                    height: "3rem",
                                                  },
                                                  attrs: {
                                                    variant: "success",
                                                    span: "Spinning",
                                                    block: "",
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "b-card-body",
                                          {
                                            staticClass: "invoice-padding pt-0",
                                          },
                                          [
                                            _c(
                                              "b-row",
                                              {
                                                staticClass: "invoice-spacing",
                                              },
                                              [
                                                _c(
                                                  "b-col",
                                                  {
                                                    staticClass: "mb-lg-1",
                                                    attrs: {
                                                      cols: "6",
                                                      xl: "6",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "h6",
                                                      { staticClass: "mb-2" },
                                                      [
                                                        _vm._v(
                                                          "Choose Supplier:*"
                                                        ),
                                                      ]
                                                    ),
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules: "required",
                                                        name: "Supplier",
                                                        vid: "supplierId",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "b-form-select",
                                                                  {
                                                                    attrs: {
                                                                      options:
                                                                        _vm.optionsCustomer,
                                                                      placeholder:
                                                                        "select supplier",
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.supplierSelected(
                                                                            _vm.supplierId
                                                                          )
                                                                        },
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .purchaseorderId
                                                                          .supplierId,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.purchaseorderId,
                                                                            "supplierId",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "purchaseorderId.supplierId",
                                                                    },
                                                                  }
                                                                ),
                                                                errors.length
                                                                  ? _c(
                                                                      "small",
                                                                      {
                                                                        staticClass:
                                                                          "text-danger",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            errors[0]
                                                                          )
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "b-col",
                                                  {
                                                    staticClass: "mb-lg-1",
                                                    attrs: {
                                                      cols: "6",
                                                      xl: "6",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "h6",
                                                      { staticClass: "mb-2" },
                                                      [
                                                        _vm._v(
                                                          "Choose Warehouse:"
                                                        ),
                                                      ]
                                                    ),
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules: "required",
                                                        name: "Warehouse",
                                                        vid: "warehouseId",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "b-form-select",
                                                                  {
                                                                    attrs: {
                                                                      placeholder:
                                                                        "select warehouse",
                                                                      options:
                                                                        _vm.optionsWarehouse,
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .purchaseorderId
                                                                          .warehouseId,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.purchaseorderId,
                                                                            "warehouseId",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "purchaseorderId.warehouseId",
                                                                    },
                                                                  }
                                                                ),
                                                                errors.length
                                                                  ? _c(
                                                                      "small",
                                                                      {
                                                                        staticClass:
                                                                          "text-danger",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            errors[0]
                                                                          )
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        !_vm.loadInvoiceData
                                          ? _c(
                                              "b-card-body",
                                              {
                                                staticClass: "invoice-padding",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    ref: "form",
                                                    staticClass:
                                                      "repeater-form",
                                                  },
                                                  _vm._l(
                                                    _vm.invoiceData.items,
                                                    function (item, index) {
                                                      return _c(
                                                        "b-row",
                                                        {
                                                          key: index,
                                                          ref: "row",
                                                          refInFor: true,
                                                          staticClass: "pb-2",
                                                        },
                                                        [
                                                          _c(
                                                            "b-col",
                                                            {
                                                              attrs: {
                                                                cols: "12",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "d-flex border rounded",
                                                                },
                                                                [
                                                                  _c(
                                                                    "b-row",
                                                                    {
                                                                      staticClass:
                                                                        "flex-grow-1 p-2",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "b-col",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              cols: "12",
                                                                              lg: "4",
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "label",
                                                                            {
                                                                              staticClass:
                                                                                "static-label",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "Items"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _vm
                                                                            .optionsProduct
                                                                            .length ===
                                                                          0
                                                                            ? _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "d-flex justify-content-center",
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "b-spinner",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          variant:
                                                                                            "primary",
                                                                                        },
                                                                                    }
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              )
                                                                            : _c(
                                                                                "div",
                                                                                [
                                                                                  _c(
                                                                                    "validation-provider",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          rules:
                                                                                            "required",
                                                                                          name: "Item",
                                                                                          vid:
                                                                                            "Item_" +
                                                                                            index,
                                                                                        },
                                                                                      scopedSlots:
                                                                                        _vm._u(
                                                                                          [
                                                                                            {
                                                                                              key: "default",
                                                                                              fn: function (
                                                                                                ref
                                                                                              ) {
                                                                                                var errors =
                                                                                                  ref.errors
                                                                                                return [
                                                                                                  _c(
                                                                                                    "v-select",
                                                                                                    {
                                                                                                      class:
                                                                                                        [
                                                                                                          {
                                                                                                            "is-invalid":
                                                                                                              errors.length,
                                                                                                          },
                                                                                                          "mb-2 item-selector-title",
                                                                                                        ],
                                                                                                      attrs:
                                                                                                        {
                                                                                                          options:
                                                                                                            _vm.optionsProduct,
                                                                                                          label:
                                                                                                            "itemTitle",
                                                                                                          disabled:
                                                                                                            item.disabledItem,
                                                                                                          clearable: false,
                                                                                                          placeholder:
                                                                                                            "Select Item",
                                                                                                        },
                                                                                                      on: {
                                                                                                        input:
                                                                                                          function (
                                                                                                            val
                                                                                                          ) {
                                                                                                            return _vm.updateItemForm(
                                                                                                              index,
                                                                                                              val
                                                                                                            )
                                                                                                          },
                                                                                                      },
                                                                                                      model:
                                                                                                        {
                                                                                                          value:
                                                                                                            item.name,
                                                                                                          callback:
                                                                                                            function (
                                                                                                              $$v
                                                                                                            ) {
                                                                                                              _vm.$set(
                                                                                                                item,
                                                                                                                "name",
                                                                                                                $$v
                                                                                                              )
                                                                                                            },
                                                                                                          expression:
                                                                                                            "item.name",
                                                                                                        },
                                                                                                    }
                                                                                                  ),
                                                                                                  errors.length
                                                                                                    ? _c(
                                                                                                        "small",
                                                                                                        {
                                                                                                          staticClass:
                                                                                                            "text-danger",
                                                                                                        },
                                                                                                        [
                                                                                                          _vm._v(
                                                                                                            _vm._s(
                                                                                                              errors[0]
                                                                                                            )
                                                                                                          ),
                                                                                                        ]
                                                                                                      )
                                                                                                    : _vm._e(),
                                                                                                ]
                                                                                              },
                                                                                            },
                                                                                          ],
                                                                                          null,
                                                                                          true
                                                                                        ),
                                                                                    }
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              ),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "b-col",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              cols: "12",
                                                                              lg: "3",
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "label",
                                                                            {
                                                                              staticClass:
                                                                                "static-label",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "Unit Price (Rs)"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "validation-provider",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  name: "Unit Price",
                                                                                  rules:
                                                                                    {
                                                                                      message_unit_price:
                                                                                        item.purchasePrice,
                                                                                      required: true,
                                                                                    },
                                                                                },
                                                                              scopedSlots:
                                                                                _vm._u(
                                                                                  [
                                                                                    {
                                                                                      key: "default",
                                                                                      fn: function (
                                                                                        ref
                                                                                      ) {
                                                                                        var errors =
                                                                                          ref.errors
                                                                                        return [
                                                                                          _c(
                                                                                            "b-form-input",
                                                                                            {
                                                                                              attrs:
                                                                                                {
                                                                                                  type: "number",
                                                                                                },
                                                                                              model:
                                                                                                {
                                                                                                  value:
                                                                                                    item.purchasePrice,
                                                                                                  callback:
                                                                                                    function (
                                                                                                      $$v
                                                                                                    ) {
                                                                                                      _vm.$set(
                                                                                                        item,
                                                                                                        "purchasePrice",
                                                                                                        $$v
                                                                                                      )
                                                                                                    },
                                                                                                  expression:
                                                                                                    "item.purchasePrice",
                                                                                                },
                                                                                            }
                                                                                          ),
                                                                                          errors.length
                                                                                            ? _c(
                                                                                                "small",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "text-danger",
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    _vm._s(
                                                                                                      errors[0]
                                                                                                    )
                                                                                                  ),
                                                                                                ]
                                                                                              )
                                                                                            : _vm._e(),
                                                                                        ]
                                                                                      },
                                                                                    },
                                                                                  ],
                                                                                  null,
                                                                                  true
                                                                                ),
                                                                            }
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                      _c(
                                                                        "b-col",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              cols: "12",
                                                                              lg: "2",
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "label",
                                                                            {
                                                                              staticClass:
                                                                                "static-label",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "Qty*"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "b-form-input",
                                                                            {
                                                                              staticClass:
                                                                                "mb-2",
                                                                              attrs:
                                                                                {
                                                                                  type: "number",
                                                                                  min: "1",
                                                                                  "invalid-feedback":
                                                                                    "Quantity must be 1 or more",
                                                                                  required:
                                                                                    "",
                                                                                },
                                                                              on: {
                                                                                change:
                                                                                  _vm.validateQuantity,
                                                                              },
                                                                              model:
                                                                                {
                                                                                  value:
                                                                                    item.qty,
                                                                                  callback:
                                                                                    function (
                                                                                      $$v
                                                                                    ) {
                                                                                      _vm.$set(
                                                                                        item,
                                                                                        "qty",
                                                                                        $$v
                                                                                      )
                                                                                    },
                                                                                  expression:
                                                                                    "item.qty",
                                                                                },
                                                                            }
                                                                          ),
                                                                          _vm.quantityError
                                                                            ? _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "invalid-feedback",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    " " +
                                                                                      _vm._s(
                                                                                        _vm.quantityError
                                                                                      ) +
                                                                                      " "
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                        ],
                                                                        1
                                                                      ),
                                                                      _c(
                                                                        "b-col",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              cols: "12",
                                                                              lg: "2",
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "d-flex align-items-center justify-content-between",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "flex-grow-1",
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "label",
                                                                                    {
                                                                                      staticClass:
                                                                                        "static-label",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "Total Price"
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                  _c(
                                                                                    "p",
                                                                                    {
                                                                                      staticClass:
                                                                                        "mb-1",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "Rs " +
                                                                                          _vm._s(
                                                                                            item.computedPrice
                                                                                          )
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "mb-1",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "b-button",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      variant:
                                                                                        "danger",
                                                                                      size: "sm",
                                                                                    },
                                                                                  on: {
                                                                                    click:
                                                                                      function (
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.removeItem(
                                                                                          index
                                                                                        )
                                                                                      },
                                                                                  },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    " Remove "
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "b-col",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              cols: "12",
                                                                              lg: "6",
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "d-inline d-lg-none",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "Description"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "b-form-textarea",
                                                                            {
                                                                              staticClass:
                                                                                "mb-2 mb-lg-0",
                                                                              model:
                                                                                {
                                                                                  value:
                                                                                    item.description,
                                                                                  callback:
                                                                                    function (
                                                                                      $$v
                                                                                    ) {
                                                                                      _vm.$set(
                                                                                        item,
                                                                                        "description",
                                                                                        $$v
                                                                                      )
                                                                                    },
                                                                                  expression:
                                                                                    "item.description",
                                                                                },
                                                                            }
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  1
                                                ),
                                                _c(
                                                  "b-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "ripple",
                                                        rawName: "v-ripple.400",
                                                        value:
                                                          "rgba(255, 255, 255, 0.15)",
                                                        expression:
                                                          "'rgba(255, 255, 255, 0.15)'",
                                                        modifiers: {
                                                          400: true,
                                                        },
                                                      },
                                                    ],
                                                    attrs: {
                                                      size: "sm",
                                                      variant: "primary",
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.addNewItemInItemForm,
                                                    },
                                                  },
                                                  [_vm._v(" Add Item ")]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _c(
                                          "b-card-body",
                                          {
                                            staticClass: "invoice-padding pb-0",
                                          },
                                          [
                                            _c(
                                              "b-row",
                                              [
                                                _c(
                                                  "b-col",
                                                  {
                                                    staticClass:
                                                      "mt-md-0 mt-3 d-flex align-items-center",
                                                    attrs: {
                                                      cols: "12",
                                                      md: "6",
                                                      order: "2",
                                                      "order-md": "1",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-nowrap mr-50",
                                                        attrs: {
                                                          for: "invoice-data-sales-person",
                                                        },
                                                      },
                                                      [_vm._v("Issuer:")]
                                                    ),
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules: "required",
                                                        name: "Sales Person",
                                                        vid: "Sales Person",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "b-form-select",
                                                                  {
                                                                    attrs: {
                                                                      options:
                                                                        _vm.optionsSalesPerson,
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .purchaseorderId
                                                                          .salesPersonId,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.purchaseorderId,
                                                                            "salesPersonId",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "purchaseorderId.salesPersonId",
                                                                    },
                                                                  }
                                                                ),
                                                                errors.length
                                                                  ? _c(
                                                                      "small",
                                                                      {
                                                                        staticClass:
                                                                          "text-danger",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            errors[0]
                                                                          )
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "b-col",
                                                  {
                                                    staticClass:
                                                      "mt-md-6 d-flex justify-content-end",
                                                    attrs: {
                                                      cols: "12",
                                                      md: "6",
                                                      order: "1",
                                                      "order-md": "2",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invoice-total-wrapper",
                                                      },
                                                      [
                                                        _c("hr", {
                                                          staticClass: "my-50",
                                                        }),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invoice-total-item",
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "invoice-total-title",
                                                              },
                                                              [_vm._v("Total:")]
                                                            ),
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "invoice-total-amount",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Rs " +
                                                                    _vm._s(
                                                                      _vm.totalPrice
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("hr", {
                                          staticClass: "invoice-spacing",
                                        }),
                                        _c(
                                          "b-card-body",
                                          {
                                            staticClass: "invoice-padding pt-0",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "font-weight-bold",
                                              },
                                              [_vm._v("Note: ")]
                                            ),
                                            _c("b-form-textarea", {
                                              model: {
                                                value: _vm.purchaseorderId.note,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.purchaseorderId,
                                                    "note",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "purchaseorderId.note",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3111275140
                      ),
                    }),
                  ],
                  1
                ),
                _c(
                  "b-col",
                  {
                    staticClass: "invoice-actions mt-md-0 mt-2",
                    attrs: { cols: "12", md: "4", xl: "3" },
                  },
                  [
                    _c(
                      "b-card",
                      [
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "ripple",
                                rawName: "v-ripple.400",
                                value: "rgba(113, 102, 240, 0.15)",
                                expression: "'rgba(113, 102, 240, 0.15)'",
                                modifiers: { 400: true },
                              },
                            ],
                            style: _vm.loadingButton
                              ? { cursor: "not-allowed" }
                              : {},
                            attrs: {
                              variant: "outline-primary",
                              block: "",
                              disabled: _vm.loadingButton,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.addSalesOrder()
                              },
                            },
                          },
                          [
                            _vm.loading
                              ? _c("b-spinner", { attrs: { small: "" } })
                              : _vm._e(),
                            _vm._v(" Save "),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }